import * as React from "react";
import Slider from "@mui/material/Slider";
import { useState } from "react";
import { PauseIcon, PlayIcon } from "../../iconSet/IconSet";

function valuetext(value: number) {
  return `${value} : 00 PM`;
}

export default function StormSurgeForecastTimeline() {
  const [value, setValue] = useState<number>(0);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

  const handlePlayPause = () => {
    setIsPlaying((prevIsPlaying) => !prevIsPlaying);
    if (!isPlaying) {
      const id = setInterval(() => {
        setValue((prevValue) => prevValue + 1);
      }, 1000);
      setIntervalId(id);
    } else {
      if (intervalId) clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  };

  return (
    <div
      style={{
        margin: "30px 0 0 0",
        width: "54vw",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ margin: "0 15px 0 0" }}>
        {isPlaying ? (
          <div
            onClick={handlePlayPause}
            onTouchStart={handlePlayPause}
            style={{
              borderRadius: "50%",
              margin: "5px 0px",
              width: "20px",
              height: "20px",
              color: "white",
              cursor: "pointer",
            }}
          >
      
           <PauseIcon width="1.3rem" color="var(--color-text)" />
          </div>
        ) : (
          <div
            onClick={handlePlayPause}
            onTouchStart={handlePlayPause}
            style={{
              borderRadius: "50%",
              margin: "5px 0px",
              width: "20px",
              height: "20px",
              color: "white",
              cursor: "pointer",
            }}
          >
               
            <PlayIcon width="1.3rem" color="var(--color-text)" /> 
          </div>
        )}
      </div>
      <div style={{ width: "90%" }}>
        <Slider
          aria-label="Always visible"
          min={1}
          max={12}
          value={value}
          onChange={handleChange}
          valueLabelFormat={valuetext}
          step={1}
          valueLabelDisplay="on"
        />
      </div>
    </div>
  );
}
